import { render, staticRenderFns } from "./StaffAttendanceDashboardModal.vue?vue&type=template&id=e3848580&scoped=true&"
import script from "./StaffAttendanceDashboardModal.vue?vue&type=script&lang=js&"
export * from "./StaffAttendanceDashboardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3848580",
  null
  
)

export default component.exports